import { memo, useCallback, useMemo, useState } from 'react';
import { Chip, SelectWrapper } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

const FontSelector = ({ editor }) => {
    const options = useMemo(
        () => [
            { label: getLiteral('label_default'), value: 'default' },
            { label: 'Arial', value: 'Arial, Helvetica, sans-serif' },
            { label: 'Verdana', value: 'Verdana, Geneva, sans-serif' },
            {
                label: 'Trebuchet MS',
                value: 'Trebuchet MS, Lucida Grande, Lucida Sans Unicode, Lucida Sans, sans-serif',
            },
            { label: 'Tahoma', value: 'Tahoma, Geneva, sans-serif' },
            { label: 'Times New Roman', value: 'Times New Roman, Times, serif' },
            { label: 'Georgia', value: 'Georgia' },
            { label: 'Courier', value: 'Courier New, Courier, monospace' },
        ],
        [],
    );

    const [font, setFont] = useState(options[0]);

    const onChange = useCallback(
        (payload) => {
            setFont(payload);

            if (payload.value === 'default') {
                editor.commands.unsetFontFamily();
            } else {
                editor.commands.setFontFamily(payload.value);
            }
        },
        [editor],
    );

    const selectProps = useMemo(
        () => ({
            className: 'fm-ee__fontSelector',
            options,
            value: font.value,
            onChange,
        }),
        [font.value, onChange, options],
    );

    const chipProps = useMemo(
        () => ({
            isUnfolded: true,
            className: 'fm-ee__editorToolbarChip',
        }),
        [],
    );

    return editor ? (
        <SelectWrapper {...selectProps}>
            <div>
                <Chip {...chipProps}>{font.label}</Chip>
            </div>
        </SelectWrapper>
    ) : null;
};

export default memo(FontSelector);
